export const couponData = [
  {
    id: "1",
    name: "WELCOME",
    value: "20%",
    desc: "GET 20% Discount",
  },
  {
    id: "2",
    name: "MASAI30",
    value: "30%",
    desc: "GET 30% Discount",
  },
];
